import type * as React from "react";

import { Button } from "components/ui/legacy/Button";

import { cn } from "@/lib/utils";

type TProps = { active?: boolean; onClick?: () => void; prefix?: React.ReactNode };

export const NavbarButton: FC<TProps> = ({ active, children, onClick, prefix, ref }) => {
  return (
    <Button
      className={cn(
        "bg-transparent text-sidebar-foreground h-8 gap-2 cursor-pointer hover:bg-sidebar-foreground/10 active:bg-sidebar-primary",
        active && "bg-sidebar-foreground/10",
      )}
      onClick={onClick}
      prefix={prefix}
      ref={ref}
      size="medium"
    >
      {children}
    </Button>
  );
};
